/* JungleSocks · Performance — configurador de packs (sections/perf-pack-builder.liquid) */
(function () {
  var TOGGLE_I18N = {
    es: ['Ver pares', 'Ocultar'],
    en: ['See pairs', 'Hide'],
    fr: ['Voir les paires', 'Masquer'],
    de: ['Paare ansehen', 'Ausblenden'],
    it: ['Vedi le paia', 'Nascondi'],
    pt: ['Ver pares', 'Ocultar']
  };

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var t = JSON.parse(root.querySelector('[data-ppb-i18n]').textContent);
    var tiers = root.dataset.tiers.split(',').map(function (s) {
      var p = s.split(':');
      return { q: +p[0], d: +p[1] };
    });
    var minPairs = +root.dataset.min || 1;
    var pkgQty = +root.dataset.pkgQty || 3;
    var slots = tiers[tiers.length - 1].q;
    var pkgEl = root.querySelector('[data-pkg-variant]');
    var pkg = pkgEl ? { id: +pkgEl.dataset.pkgVariant, price: +pkgEl.dataset.pkgPrice } : null;

    var state = { lines: [], pkg: false, step: 1 };
    var shown = 0;

    var $ = function (sel) { return root.querySelector(sel); };
    var slotEls = root.querySelectorAll('.ppb__slot');

    /* Móvil: botón para desplegar la lista de pares (talla + quitar) en el resumen fijo */
    var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
    var tl = TOGGLE_I18N[lang] || TOGGLE_I18N.es;
    var summary = $('[data-summary]');
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ppb__toggle';
    toggle.setAttribute('data-toggle', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.hidden = true;
    $('.ppb__sum-head').appendChild(toggle);
    var mqMobile = window.matchMedia('(max-width: 989px)');
    function setOpen(open) {
      summary.classList.toggle('is-open', !!open);
      toggle.setAttribute('aria-expanded', String(!!open));
      toggle.textContent = open ? tl[1] + ' ↓' : tl[0] + ' ↑';
    }
    setOpen(false);

    function money(cents) {
      var parts = (Math.round(cents) / 100).toFixed(2).split('.');
      var fmt = function (sep, dec, decimals) {
        var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        return decimals ? i + dec + parts[1] : i;
      };
      return t.format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        switch (k) {
          case 'amount_no_decimals': return fmt(',', '.', false);
          case 'amount_with_comma_separator': return fmt('.', ',', true);
          case 'amount_no_decimals_with_comma_separator': return fmt('.', ',', false);
          case 'amount_with_apostrophe_separator': return fmt("'", '.', true);
          default: return fmt(',', '.', true);
        }
      });
    }
    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* Fila de descuentos bajo los huecos */
    var tierRow = $('[data-tier-row]');
    for (var i = 1; i <= slots; i++) {
      var cell = document.createElement('span');
      cell.className = 'ppb__tier';
      tiers.forEach(function (tr) {
        if (tr.q === i) {
          cell.textContent = '−' + tr.d + ' %';
          cell.dataset.q = tr.q;
          slotEls[i - 1].classList.add('is-tier');
        }
      });
      tierRow.appendChild(cell);
    }

    function count() {
      return state.lines.reduce(function (s, l) { return s + l.qty; }, 0);
    }
    function tierFor(n) {
      var r = null;
      tiers.forEach(function (tr) { if (n >= tr.q) r = tr; });
      return r;
    }

    function render() {
      var n = count();
      var units = [];
      state.lines.forEach(function (l) { for (var k = 0; k < l.qty; k++) units.push(l); });

      /* mensaje */
      var reached = null, next = null;
      tiers.forEach(function (tr) {
        if (n >= tr.q) reached = tr;
        else if (!next) next = tr;
      });
      var msg;
      if (n === 0) msg = t.empty.replace('[n]', minPairs);
      else if (!reached) msg = t.need.replace('[n]', n).replace('[u]', n === 1 ? t.one : t.many).replace('[left]', next.q - n).replace('[d]', next.d);
      else if (next) msg = t.mid.replace('[d]', reached.d).replace('[left]', next.q - n).replace('[d2]', next.d);
      else msg = t.max.replace('[d]', reached.d);
      $('[data-msg]').innerHTML = msg;
      $('[data-n]').textContent = n;

      /* huecos: foto + talla */
      slotEls.forEach(function (el, idx) {
        var u = units[idx];
        var wasFull = el.classList.contains('is-full');
        el.classList.toggle('is-full', !!u);
        el.classList.remove('is-new');
        if (u) {
          var more = idx === slots - 1 && n > slots ? '<span class="ppb__more">+' + (n - slots) + '</span>' : '';
          el.innerHTML = (u.img ? '<img src="' + esc(u.img) + '" alt="" width="80" height="80">' : '') +
            '<span class="ppb__slot-size">' + esc(u.size) + '</span>' + more;
          el.title = u.title + ' · ' + u.size;
          if (!wasFull && idx >= shown) el.classList.add('is-new');
        } else {
          el.innerHTML = '<span class="ppb__num">' + (idx + 1) + '</span>';
          el.removeAttribute('title');
        }
      });
      shown = Math.min(n, slots);
      tierRow.querySelectorAll('[data-q]').forEach(function (c) {
        c.classList.toggle('is-on', n >= +c.dataset.q);
      });

      /* líneas */
      $('[data-lines]').innerHTML = state.lines.map(function (l, idx) {
        return '<li class="ppb__line">' +
          (l.img ? '<img src="' + esc(l.img) + '" alt="" width="36" height="36" loading="lazy">' : '<span></span>') +
          '<span class="ppb__line-name">' + esc(l.title) + '<small>' + esc(l.size) + '</small></span>' +
          '<span class="ppb__line-qty">×' + l.qty + '</span>' +
          '<button type="button" class="ppb__rm" data-rm="' + idx + '" aria-label="' + esc(t.remove + ' ' + l.title + ' ' + l.size) + '">−</button>' +
          '</li>';
      }).join('');
      toggle.hidden = n === 0;
      if (n === 0) setOpen(false);

      /* contadores en tarjetas */
      root.querySelectorAll('.ppb__card').forEach(function (card) {
        var pid = card.dataset.product;
        var c = state.lines.filter(function (l) { return l.product === pid; }).reduce(function (s, l) { return s + l.qty; }, 0);
        var badge = card.querySelector('[data-count]');
        badge.hidden = !c;
        badge.textContent = '×' + c;
      });

      /* totales */
      var sub = state.lines.reduce(function (s, l) { return s + l.price * l.qty; }, 0);
      var tr = tierFor(n);
      var pct = tr ? tr.d : 0;
      var disc = state.lines.reduce(function (s, l) { return s + Math.round(l.price * l.qty * pct / 100); }, 0);
      var pkgOk = pkg && n === pkgQty;
      if (!pkgOk) state.pkg = false;
      var pkgTotal = state.pkg ? pkg.price : 0;
      $('[data-subtotal]').textContent = money(sub);
      $('[data-discount]').textContent = '−' + money(disc);
      $('[data-pct]').textContent = pct ? '(−' + pct + ' %)' : '';
      $('[data-pkg-line]').hidden = !state.pkg;
      if (state.pkg) $('[data-pkg-total]').textContent = '+' + money(pkgTotal);
      $('[data-total]').textContent = money(sub - disc + pkgTotal);

      /* botones */
      var next1 = $('[data-next]');
      next1.disabled = n < minPairs;
      next1.textContent = n < minPairs ? t.min.replace('[n]', minPairs) : t.next + ' →';
      next1.hidden = state.step !== 1;
      $('[data-submit]').hidden = state.step !== 2;

      /* paso 2: packaging */
      if (pkgEl) {
        var yes = root.querySelector('[data-pkg="1"]');
        var no = root.querySelector('[data-pkg="0"]');
        yes.disabled = !pkgOk;
        yes.setAttribute('aria-pressed', String(!!state.pkg));
        no.setAttribute('aria-pressed', String(!state.pkg));
        var rule = root.querySelector('[data-pkg-rule]');
        rule.classList.toggle('is-warn', !pkgOk);
      }
    }

    function setStep(s) {
      state.step = s;
      root.dataset.step = s;
      setOpen(false);
      root.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = +p.dataset.panel !== s; });
      root.querySelectorAll('[data-step-tab]').forEach(function (el) {
        var k = +el.dataset.stepTab;
        el.classList.toggle('is-on', k === s);
        el.classList.toggle('is-done', k < s);
      });
      render();
      var top = root.getBoundingClientRect().top + window.scrollY - 80;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    /* Tallas: cada tarjeta tiene su propia talla (no se copia a las demás) */
    function pickSize(card, btn) {
      card.querySelectorAll('.ppb__size').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      card.querySelector('[data-add]').disabled = !btn;
    }

    /* Móvil: tocar los huecos también despliega la lista */
    $('[data-slots]').addEventListener('click', function () {
      if (mqMobile.matches && state.step === 1 && count() > 0) setOpen(true);
    });

    root.addEventListener('click', function (e) {
      var el = e.target.closest('button');
      if (!el || !root.contains(el)) return;

      if (el.hasAttribute('data-toggle')) {
        setOpen(!summary.classList.contains('is-open'));
        return;
      }
      if (el.dataset.filter) {
        root.querySelectorAll('[data-filter]').forEach(function (b) { b.setAttribute('aria-selected', String(b === el)); });
        root.querySelectorAll('.ppb__card').forEach(function (c) {
          c.classList.toggle('is-hidden', el.dataset.filter !== 'all' && c.dataset.type !== el.dataset.filter);
        });
        return;
      }
      if (el.classList.contains('ppb__size')) {
        pickSize(el.closest('.ppb__card'), el);
        return;
      }
      if (el.hasAttribute('data-add')) {
        var card = el.closest('.ppb__card');
        var sel = card.querySelector('.ppb__size[aria-pressed="true"]');
        if (!sel) return;
        var id = +sel.dataset.variant;
        var line = state.lines.filter(function (l) { return l.id === id; })[0];
        if (line) line.qty += 1;
        else state.lines.push({ id: id, product: card.dataset.product, title: sel.dataset.title, size: sel.dataset.size, price: +sel.dataset.price, img: sel.dataset.img, qty: 1 });
        render();
        return;
      }
      if (el.dataset.rm !== undefined) {
        var l = state.lines[+el.dataset.rm];
        if (l) {
          l.qty -= 1;
          if (l.qty <= 0) state.lines.splice(+el.dataset.rm, 1);
          shown = Math.min(shown, count());
        }
        render();
        return;
      }
      if (el.hasAttribute('data-next')) { setStep(2); return; }
      if (el.hasAttribute('data-back')) { setStep(1); return; }
      if (el.dataset.pkg !== undefined) { state.pkg = el.dataset.pkg === '1'; render(); return; }
      if (el.hasAttribute('data-submit')) { submit(el); return; }
    });

    function submit(btn) {
      var packId = 'P' + Date.now().toString(36).toUpperCase();
      var items = state.lines.map(function (l) {
        return { id: l.id, quantity: l.qty, properties: { _pack: packId } };
      });
      if (state.pkg && pkg) items.push({ id: pkg.id, quantity: 1, properties: { _pack: packId } });
      var err = $('[data-error]');
      err.hidden = true;
      btn.disabled = true;
      btn.textContent = t.adding;

      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || 'error');
          state.lines = [];
          state.pkg = false;
          shown = 0;
          setStep(1);
          if (drawer && typeof drawer.renderContents === 'function' && res.json.sections) {
            res.json.id = items[0].id;
            drawer.renderContents(res.json);
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else {
            window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
          }
        })
        .catch(function (e) {
          err.textContent = (e && e.message && e.message !== 'error') ? e.message : err.textContent;
          err.hidden = false;
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = t.submit + ' →';
        });
    }

    /* Móvil: el resumen fijo solo mientras la sección está en pantalla */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting;
        root.classList.toggle('is-out', out);
        if (out) setOpen(false);
      }, { rootMargin: '0px 0px -40% 0px' }).observe(root.querySelector('.ppb__layout'));
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-ppb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
